export default __webpack_public_path__ + "static/media/Rebbit.567a01b1.svg";